import { RoutineColors } from "@/utilities/routineColors";
import type { Routine } from "instantdb/types";

export const STRESS_ROUTINES: Partial<Routine>[] = [
  {
    id: "breathing-exercises",
    title: "Breathing Exercises",
    symbol: "🧘",
    description: "Simple breathing techniques to reduce stress",
    dailyRoutine: true,
    selectedDays: [],
    color: RoutineColors[6].value,
    steps: [
      {
        id: "stress-breathing-1",
        title: "Find a quiet place",
        description: "Sit comfortably in a quiet location",
      },
      {
        id: "stress-breathing-2",
        title: "Deep breathing",
        description: "Breathe deeply through your nose for 4 counts",
      },
      {
        id: "stress-breathing-3",
        title: "Hold and release",
        description: "Hold for 4 counts, then exhale slowly for 6 counts",
      },
      {
        id: "stress-breathing-4",
        title: "Repeat cycle",
        description: "Continue for 5-10 minutes",
      },
    ],
  },
  {
    id: "progressive-relaxation",
    title: "Progressive Relaxation",
    symbol: "🧘",
    description: "Systematically relax your body to reduce tension",
    dailyRoutine: true,
    selectedDays: [],
    color: RoutineColors[7].value,
    steps: [
      {
        id: "stress-relaxation-1",
        title: "Prepare",
        description: "Find a comfortable position and close your eyes",
      },
      {
        id: "stress-relaxation-2",
        title: "Tension cycle",
        description: "Tense each muscle group for 5 seconds",
      },
      {
        id: "stress-relaxation-3",
        title: "Release cycle",
        description: "Release tension and notice the difference",
      },
      {
        id: "stress-relaxation-4",
        title: "Complete body scan",
        description: "Progress through all major muscle groups",
      },
    ],
  },
  {
    id: "stress-relief-movement",
    title: "Stress Relief Movement",
    symbol: "🏃",
    description: "Use physical activity to reduce stress hormones",
    dailyRoutine: false,
    selectedDays: [
      { day: "monday", datetime: "17:00:00.000Z" },
      { day: "wednesday", datetime: "17:00:00.000Z" },
      { day: "friday", datetime: "17:00:00.000Z" },
    ],
    color: RoutineColors[8].value,
    steps: [
      {
        id: "stress-movement-1",
        title: "Warm up",
        description: "Gentle movement to prepare your body",
      },
      {
        id: "stress-movement-2",
        title: "Aerobic activity",
        description: "Walking, running, or other cardio for 15-30 minutes",
      },
      {
        id: "stress-movement-3",
        title: "Mindful movement",
        description: "Add yoga or stretching to release tension",
      },
      {
        id: "stress-movement-4",
        title: "Cool down",
        description: "Slow, gentle movements to end your session",
      },
    ],
  },
];
